import { combineReducers } from "redux";
import loader from "../loader";
import languge from "../language";
import localizationReducer from "../localization";
import auth from "../auth";
import garageCart from "../garageCart";

const reducers = combineReducers({
  loader: loader.reducers,
  locale: localizationReducer,
  language: languge.reducers,
  auth: auth.reducers,
  garage: garageCart.reducers,
});

export default reducers;
